import { Component, OnInit, Input, SimpleChanges, Injector, OnChanges } from '@angular/core';
import { InputCost } from '../inputmodels/inputcost.model';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { TwoBarParams } from 'src/app/cp-barschart/cp-bar';
import { PageBase } from 'src/app/shared/library/page.base';

@Component({
    selector: 'cp-input-quantity-cost',
    templateUrl: './inputquantitycost.component.html',
    styleUrls: ['./inputquantitycost.component.css'],
    standalone: false
})
export class InputQuantityCostComponent extends PageBase implements OnInit, OnChanges {

  @Input() inputCost: InputCost = new InputCost();
  @Input() isHideLoading: boolean;
  inputItem: InputItem = new InputItem();
  paramChart = new TwoBarParams();
  plannedValue: number;
  appropiateValue: number;

  constructor(public objInjector: Injector)
  {
    super(objInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.inputCost.id = 0;
    this.inputCost.appropriateQuantity = 0;
    this.inputCost.appropriateValue = 0;
    this.inputCost.percentageAppropriateQuantityUnderPlannedQuantity = 0;
    this.inputCost.percentageAppropriateValueUnderPlannedValue = 0;
    this.inputCost.plannedQuantity = 0;
    this.inputCost.plannedValue = 0;
    this.plannedValue = 0;
    this.appropiateValue = 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inputCost) {
      this.load();
    }
  }

  async load() {
    if (typeof (this.inputCost.percentageAppropriateQuantityUnderPlannedQuantity) !== 'undefined') {
      this.paramChart = new TwoBarParams();
      this.paramChart.percentageAppropriateUnderPlanned = this.inputCost.percentageAppropriateQuantityUnderPlannedQuantity;
      this.paramChart.appropiateValue = this.inputCost.appropriateQuantity;
      this.paramChart.plannedValue = this.inputCost.plannedQuantity;
      this.appropiateValue = this.inputCost.appropriateQuantity;
      this.plannedValue = this.inputCost.plannedQuantity;
    }
  }

  onReceiveLiterals(): void {}

}
